export default (count: number) => ({
  dataSetName: 'Zeitenübersicht',
  dataName: 'Zeitwert',
  head: [
    {
      label: `Zeitwertbezeichnung (${count})`,
      key: 'articleName',
      col: 8,
      leftAlign: true,
    },
    {
      label: 'Rigips Zeitwert',
      key: 'listTime',
      col: 2,
      unit: 'h',
    },
    {
      label: 'Eigener Zeitwert',
      key: 'customTime',
      col: 2,
      placeholder: '0,000',
      unit: 'h',
    },
  ],
})
